<template>
     <main class="page-main">
        <Breadcrumbs>
            <template slot="li">
                <li>/<span> Voucher Section</span></li>
            </template>
        </Breadcrumbs>

        <div class="block">
            <div class="container">
                <div class="title center">
                    <h1>Voucher Section</h1>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-6">
                <a @click="$router.push({name: 'VoucherSearch'})" class="banner-wrap">
                    <div class="banner style-9 autosize-text image-hover-scale" data-fontratio="6.4" style="font-size: 100px;">
                        <img src="">
                        <div class="banner-caption vertb horc">
                            <div class="vert-wrapper">
                                <div class="vert">
                                    <div class="text-1 text-hoverslide" data-hcolor="#ffffff">
                                        <span>
                                            <span class="text">
                                                <i class="icon icon-cart-1"></i> &nbsp; Search for Vouchers</span>
                                            <span class="hoverbg"></span>
                                        </span>
                                    </div>
                                    <div class="text-2"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </main>
</template>

<script>
export default {
    name: "VoucherArea"
}
</script>



// WEBPACK FOOTER //
// src/components/vouchers/List.vue